import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { BotComparison } from '../components/BotComparison';
import { LeakSection } from '../components/LeakSection';
import { WorkingExamples } from '../components/WorkingExamples';
import { WhoItIsFor } from '../components/WhoItIsFor';
import { NextStepPanel } from '../components/NextStepPanel';
import { usePageTitle } from '../hooks/usePageTitle';
export function Why() {
  usePageTitle('Why | You were right to turn it off | Viridia Analytics');
  return <>
      <PageHeader eyebrow="Why" title="You were right to turn it off." body="Most AI tools sold to agents deserve it. Here is the difference between what you tried and what we run." data-id="element-468" data-mp="du4d8tk8eugs" />
      <BotComparison data-id="element-469" data-mp="4zzpwk4b4160" />
      <LeakSection data-id="element-470" data-mp="4yoous28x7il" />
      <WorkingExamples data-id="element-471" data-mp="11i5hhqadnoqe" />
      <WhoItIsFor data-id="element-472" data-mp="11inp1j2hppdm" />
      <NextStepPanel title="So who is Viridia to run this for you?" buttonLabel="Why teams hire Viridia" to="/why-viridia" data-id="element-473" data-mp="11j72amh73plb" />
    </>;
}